// 获取菜单栏的数据

export default{
    namespaced: true,
    state: {
        menuData:[]
    },
    mutations: {
        changeMenuData(state,payload){
            state.menuData=payload
        }
    }
}